import React, { useEffect, useState } from 'react';
import Modal from '../ui/Modal';
import Button from '../ui/Button';
import FormField from '../ui/FormField';
import Input from '../ui/Input';
import { useT } from '../../i18n/LocaleContext';

const emptyForm = { name: '', address: '', departureTime: '', active: true };

export default function LocationFormModal({ isOpen, onClose, onSubmit, initial }) {
  const t = useT();
  const isEdit = Boolean(initial);
  const [form, setForm] = useState(emptyForm);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setForm(initial ? {
      name: initial.name || '',
      address: initial.address || '',
      departureTime: initial.departureTime || '',
      active: initial.active !== false,
    } : emptyForm);
    setErrors({});
  }, [isOpen, initial]);

  const set = (field) => (e) => {
    const value = e?.target ? (e.target.type === 'checkbox' ? e.target.checked : e.target.value) : e;
    setForm((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim()) {
      setErrors({ name: t('validation.required') });
      return;
    }
    setSubmitting(true);
    try {
      await onSubmit({
        name: form.name.trim(),
        address: form.address.trim() || null,
        departureTime: form.departureTime || null,
        active: form.active,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={submitting ? () => {} : onClose}
      title={isEdit ? t('transport_page.edit_location') : t('transport_page.new_location')}
      size="sm"
      footer={(
        <>
          <Button variant="ghost" onClick={onClose} disabled={submitting}>{t('common.cancel')}</Button>
          <Button variant="gold" onClick={handleSubmit} loading={submitting}>
            {isEdit ? t('common.save') : t('common.create')}
          </Button>
        </>
      )}
    >
      <form onSubmit={handleSubmit} noValidate>
        <FormField label={t('transport_page.field_location_name')} htmlFor="loc-name" required error={errors.name}>
          <Input id="loc-name" value={form.name} onChange={set('name')} invalid={Boolean(errors.name)} maxLength={120} placeholder="Nyabugogo" autoFocus />
        </FormField>
        <FormField label={t('transport_page.field_address')} htmlFor="loc-address" hint={t('common.optional')}>
          <Input id="loc-address" value={form.address} onChange={set('address')} maxLength={255} />
        </FormField>
        <FormField label={t('transport_page.field_departure_time')} htmlFor="loc-time" hint={t('transport_page.departure_time_hint')}>
          <Input id="loc-time" type="time" value={form.departureTime} onChange={set('departureTime')} />
        </FormField>
        <label className="checkbox-row">
          <input type="checkbox" checked={form.active} onChange={set('active')} />
          <span>{t('transport_page.active_location')}</span>
        </label>
      </form>
    </Modal>
  );
}
